export default __webpack_public_path__ + "static/media/linkedin.1d8753a9.svg";